export class Dependant {
    public id!: number;
    public name!: string;
    public entityId!: number;
    public entityType!: string;
    public type?: string; //td=transformation, ff=filter, vf=validation, ad=allocation, fc=consolidation, md=moov definition
    public configurationsCount?: number; //moov definitions only

    private static readonly typeNames:{type:string, singular:string, plural:string}[] = [
        {type:'md', singular:'moov definition', plural:'moov definitions'},
        {type:'td', singular:'transformation definition', plural:'transformation definitions'},
        {type:'ff', singular:'filter definition', plural:'filter definitions'},
        {type:'vf', singular:'validation definition', plural:'validation definitions'},
        {type:'ad', singular:'allocation definition', plural:'allocation definitions'},
        {type:'fc', singular:'consolidation definition', plural:'consolidation definitions'}
    ];

    //dependants grouped by type, moov definitions first. dependants without type (older api versions) are treated as transformation definitions
    public static groupByType(dependants:Dependant[]):{type:string, label:string, dependants:Dependant[]}[]{
        return Dependant.typeNames
            .map(tn=>({type:tn.type, label:tn.plural.charAt(0).toUpperCase()+tn.plural.slice(1), dependants:dependants.filter(d=>(d.type ?? 'td')==tn.type)}))
            .filter(g=>g.dependants.length>0);
    }

    //html summary for confirmation dialogs, e.g. "2 moov definitions (5 configurations): A, B"
    public static summary(dependants:Dependant[]):string{
        return Dependant.groupByType(dependants).map(g=>{
            const typeName = Dependant.typeNames.find(tn=>tn.type==g.type)!;
            let line = g.dependants.length + ' ' + (g.dependants.length==1 ? typeName.singular : typeName.plural);
            if(g.type=='md'){
                const configurationsCount = g.dependants.reduce((sum,d)=>sum+(d.configurationsCount ?? 0),0);
                line += ' (' + configurationsCount + ' configuration' + (configurationsCount==1 ? '' : 's') + ')';
            }
            return line + ': ' + g.dependants.map(d=>Dependant.escapeHtml(d.name)).join(', ');
        }).join('<br/>');
    }

    private static escapeHtml(text:string):string{
        return (text ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    }
}
